import React from 'react';

const PropertyComplianceTab = () => (
    <div className="bg-white shadow sm:rounded-lg p-8 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
        <h3 className="text-lg font-medium text-gray-900 mb-1">Compliance Tracking</h3>
        <p className="text-sm text-gray-500">Landlord FICA and compliance document tracking is coming in Epic 7.</p>
    </div>
);

export default PropertyComplianceTab;
